import { paletteTypes } from './actionTypes'
import { PaletteActions, PaletteState } from './types'

const initialState: PaletteState = {
    palette: undefined,
    templates: [],
    colorsTemplates: [],
    imagesTemplates: [],
    activePalette: undefined,
}

export default (state = initialState, action: PaletteActions): PaletteState => {
    switch (action.type) {
        case paletteTypes.SET_PALETTE:
            return {
                ...state,
                palette: action.payload.palette
                    ? { ...action.payload.palette }
                    : undefined,
            }
        case paletteTypes.SET_TEMPLATES:
            return {
                ...state,
                templates: action.payload.templates,
            }
        case paletteTypes.SET_COLORS_TEMPLATES:
            return {
                ...state,
                colorsTemplates: action.payload.colorsTemplates,
            }
        case paletteTypes.SET_IMAGES_TEMPLATES:
            return {
                ...state,
                imagesTemplates: action.payload.imagesTemplates,
            }
        case paletteTypes.SET_ACTIVE_PALETTE:
            return {
                ...state,
                activePalette: action.payload.activePalette,
            }
        case paletteTypes.UPDATE_ACTIVE_PALETTE:
            return {
                ...state,
                activePalette: state.activePalette
                    ? { ...state.activePalette, ...action.payload.updates }
                    : action.payload.updates,
            }
        default:
            return {
                ...state,
            }
    }
}
